module.exports = __webpack_public_path__ + "img/226.27af90d8.png";